import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../resource';
import HotSearchForm from './HotSearchForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateHotSearch = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.hotSearch,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.hot-search.createSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            notify(error.message || t('module.hot-search.updateFailed'), { type: 'error' });
            break;
        }
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.hot-search.createConfiguration')}</DialogTitle>
        <DialogContent>
          <HotSearchForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="hotSearching" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateHotSearch;
